<template>
  <div class="columns is-mobile">
    <div class="column">
      <b-field
        label="How Injury/Illness Occurred; Describe Sequence of Events"
        :type="{'is-danger': errors.has('injurydetails.claimInjuryDescription')}"
        :message="errors.first('injurydetails.claimInjuryDescription')"
      >
        <b-input
          maxlength="500"
          type="textarea"
          v-model="fnoldata.injury.claimInjuryDescription"
          name="claimInjuryDescription"
          v-validate="'required'"
          data-vv-as="Injury/Illness"
          data-vv-scope="injurydetails"
        ></b-input>
      </b-field>
      <b-field label="Other Workers Injured/Ill in this event?" expanded>
        <b-switch
          v-model="fnoldata.injury.rbOthInj"
          true-value="Yes"
          false-value="No"
          expanded
        >{{ fnoldata.injury.rbOthInj }}</b-switch>
      </b-field>
      <b-field
        label="Part of Body Affected"
        expanded
        :type="{'is-danger': errors.has('injurydetails.bodypart')}"
        :message="errors.first('injurydetails.bodypart')"
      >
        <b-select
          name="bodypart"
          v-model="fnoldata.injury.bodyPart"
          placeholder="Please select"
          expanded
          v-validate="'required'"
          data-vv-as="Body part"
          data-vv-scope="injurydetails"
        >
          <option v-for="(value, key) in detailedBodyPartSortedList" :value="value" :key="key">{{ key }}</option>
        </b-select>
      </b-field>
      <b-field label="Medical Diagnosis (If available)">
        <b-input
          maxlength="150"
          type="textarea"
          v-model="fnoldata.injury.medicalDiagnosis"
          name="medicalDiagnosis"
        ></b-input>
      </b-field>

      <b-field label="If employee died, date of death" expanded>
        <b-datepicker
          placeholder="Select a date..."
          icon="calendar-today"
          v-model="fnoldata.injury.dateofDeath"
        >
         <button class="button is-warning"
                @click="fnoldata.injury.dateofDeath = new Date()">
                <b-icon icon="calendar-today"></b-icon>
                <span>Today</span>
            </button>
            <button class="button is-warning"
                @click="fnoldata.injury.dateofDeath = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
        </b-datepicker>
      </b-field>
      <b-field label="Unable to work atleast one full day after date of Injury?">
        <b-switch
          v-model="fnoldata.injury.rbOneDay"
          true-value="Yes"
          false-value="No"
        >{{ fnoldata.injury.rbOneDay }}</b-switch>
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field label="Date Last worked" expanded>
            <b-datepicker
              name="dateLastWeekWorked"
              placeholder="Select a date..."
              icon="calendar-today"
              v-model="fnoldata.injury.dateLastWeekWorked"
            >
            <button class="button is-warning"
                @click="fnoldata.injury.dateLastWeekWorked = new Date()">
                <b-icon icon="calendar-today"></b-icon>
                <span>Today</span>
            </button>
            <button class="button is-warning"
                @click="fnoldata.injury.dateLastWeekWorked = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
          <b-field label="Date returned to work" expanded>
            <b-datepicker
              name="employeeReturnedToWork"
              placeholder="Click to select..."
              icon="calendar-today"
              v-model="fnoldata.injury.employeeReturnedToWork"
            >
            <button class="button is-warning"
                @click="fnoldata.injury.employeeReturnedToWork = new Date()">
                <b-icon icon="calendar-today"></b-icon>
                <span>Today</span>
            </button>
            <button class="button is-warning"
                @click="fnoldata.injury.employeeReturnedToWork = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Still off work?" expanded>
            <b-switch
              v-model="fnoldata.injury.rbInjoffWk"
              true-value="Yes"
              false-value="No"
            >{{ fnoldata.injury.rbInjoffWk }}</b-switch>
          </b-field>
        </div>
        <div class="column">
          <b-field label=" Paid Full Wages, For Day Of Injury, Or Last Day Worked?" expanded>
            <b-switch
              v-model="fnoldata.injury.employeePaidInjuryDay"
              true-value="Yes"
              false-value="No"
            >{{ fnoldata.injury.employeePaidInjuryDay }}</b-switch>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Salary being continued?" expanded>
            <b-switch
              v-model="fnoldata.injury.employeeSalaryContinuted"
              true-value="Yes"
              false-value="No"
            >{{ fnoldata.injury.employeeSalaryContinuted }}</b-switch>
          </b-field>
        </div>
      </div>

      <b-field label="Injured worker treated in emergency room?">
        <b-switch
          v-model="fnoldata.hospital.emergency"
          true-value="Yes"
          false-value="No"
          expanded
        >{{ fnoldata.hospital.emergency }}</b-switch>
      </b-field>
      <br />
      <div class="card" v-if="fnoldata.hospital.emergency ==='Yes'">
        <div class="card-header">
          <p class="card-header-title">Hospital Information</p>
        </div>
        <div class="card-content">
          <div class="content">
            <b-field
              label="Name"
              :type="{'is-danger': errors.has('hname')}"
              :message="errors.first('hname')"
            >
              <b-input v-model="fnoldata.hospital.name" name="hname" />
            </b-field>
            <b-field label="Hospitalized as an Inpatient?">
              <b-switch
                v-model="fnoldata.injury.hospitaliz"
                true-value="Yes"
                false-value="No"
                expanded
              >{{ fnoldata.injury.hospitaliz }}</b-switch>
            </b-field>
            <b-field
              label="Phone"
              :type="{'is-danger': errors.has('hwork')}"
              :message="errors.first('hwork')"
            >
              <b-input v-model="hospitalPhone" maxlength="16" v-validate="'min:16'" name="hwork" />
            </b-field>
            <b-field
              label="Mailing Address"
              :type="{'is-danger': errors.has('injurydetails.hmailingaddress')}"
              :message="errors.first('injurydetails.hmailingaddress')"
            >
              <b-input
                v-model="fnoldata.hospital.address.street"
                name="hmailingaddress"
                v-validate="'required'"
                data-vv-as="Mailing Address"
                data-vv-scope="injurydetails"
              />
            </b-field>
            <div class="columns">
              <div class="column">
                <b-field
                  label="City"
                  :type="{'is-danger': errors.has('injurydetails.hcity')}"
                  :message="errors.first('injurydetails.hcity')"
                  expanded
                >
                  <b-input
                    v-model="fnoldata.hospital.address.city"
                    name="hcity"
                    v-validate="'required'"
                    data-vv-as="City"
                    data-vv-scope="injurydetails"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field
                  label="State"
                  expanded
                  :type="{'is-danger': errors.has('injurydetails.hstate')}"
                  :message="errors.first('injurydetails.hstate')"
                >
                  <b-select
                    name="hstate"
                    v-model="fnoldata.hospital.address.state"
                    placeholder="Please select"
                    v-validate="'required'"
                    expanded
                    data-vv-as="State"
                    data-vv-scope="injurydetails"
                  >
                    <option v-for="(key, value) in stateMap" :value="value" :key="value">{{ key }}</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field
                  label="Zip code"
                  :type="{'is-danger': errors.has('injurydetails.hzipcode')}"
                  :message="errors.first('injurydetails.hzipcode')"
                >
                  <b-input
                    v-model="fnoldata.hospital.address.zip"
                    name="hzipcode"
                    v-validate="{ required: true, regex:/^\d{5}(-\d{4})?$/ }"
                    data-vv-as="Zip code"
                    data-vv-scope="injurydetails"
                    maxlength="10"
                  />
                </b-field>
              </div>
            </div>
          </div>
        </div>
        </div>
        <br />

      <b-field label="Did injured worker seek medical treatment?">
        <b-switch
          v-model="fnoldata.injury.seekMedicalTreatment"
          true-value="Yes"
          false-value="No"
        >{{ fnoldata.injury.seekMedicalTreatment }}</b-switch>
      </b-field>

      <div class="card" v-if="fnoldata.injury.seekMedicalTreatment === 'Yes'">
        <div class="card-header">
          <p class="card-header-title">Physician/Clinic Information</p>
        </div>
        <div class="card-content" aria-controls="medicaltreatmentarea">
          <div class="content" aria-controls="medicaltreatmentarea">
            <b-field
              label="Name"
              :type="{'is-danger': errors.has('Name')}"
              :message="errors.first('name')"
            >
              <b-input v-model="fnoldata.physicianORClinic.name" name="name" />
            </b-field>
            <b-field
              label="Phone"
              :type="{'is-danger': errors.has('work')}"
              :message="errors.first('work')"
            >
              <b-input v-model="physicianPhone" maxlength="16" v-validate="'min:16'" name="work" />
            </b-field>
            <b-field
              label="Mailing Address"
              :type="{'is-danger': errors.has('injurydetails.medmailingaddress')}"
              :message="errors.first('injurydetails.medmailingaddress')"
            >
              <b-input
                v-model="fnoldata.physicianORClinic.address.street"
                name="medmailingaddress"
                v-validate="'required'"
                data-vv-as="Mailing Address"
                data-vv-scope="injurydetails"
              />
            </b-field>
            <div class="columns">
              <div class="column">
                <b-field
                  label="City"
                  :type="{'is-danger': errors.has('injurydetails.medcity')}"
                  :message="errors.first('injurydetails.medcity')"
                  expanded
                >
                  <b-input
                    v-model="fnoldata.physicianORClinic.address.city"
                    name="medcity"
                    v-validate="'required'"
                    data-vv-as="City"
                    data-vv-scope="injurydetails"
                  />
                </b-field>
              </div>
              <div class="column">
                <b-field
                  label="State"
                  expanded
                  :type="{'is-danger': errors.has('injurydetails.medstate')}"
                  :message="errors.first('injurydetails.medstate')"
                >
                  <b-select
                    v-model="fnoldata.physicianORClinic.address.state"
                    placeholder="Please select"
                    name="medstate"
                    v-validate="'required'"
                    data-vv-as="State"
                    data-vv-scope="injurydetails"
                    expanded
                  >
                    <option v-for="(key, value) in stateMap" :value="value" :key="value">{{ key }}</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field
                  label="Zip code"
                  :type="{'is-danger': errors.has('injurydetails.medzipcode')}"
                  :message="errors.first('injurydetails.medzipcode')"
                >
                  <b-input
                    v-model="fnoldata.physicianORClinic.address.zip"
                    name="medzipcode"
                    v-validate="{ required: true, regex:/^\d{5}(-\d{4})?$/ }"
                    data-vv-as="Zip code"
                    data-vv-scope="injurydetails"
                    maxlength="10"
                  />
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TypeLists from "../data/typelists";
import { PhoneFormatter, ZipFormatter } from "../utils/util";

export default {
  props: ["fnoldata"],
  name: "InjuryDetails",
  inject: ["parentValidator"],
  created() {
    this.$validator = this.parentValidator;
  },
  data() {
    return {
      detaildBodyPartList: TypeLists.DetailedBodyPart,
      detailedBodyPartSortedList: TypeLists.DetailedBodyPartSorted,
      physicianPhone: PhoneFormatter(
        this.fnoldata.physicianORClinic.phone.work
      ),
      hospitalPhone: PhoneFormatter(this.fnoldata.hospital.phone.work),
      stateMap: TypeLists.StatesFiltered
    };
  },
  watch: {
    physicianPhone: function(input) {
      //alert(input);
      input = PhoneFormatter(input);
      this.physicianPhone = input;
      this.fnoldata.physicianORClinic.phone.work = input.replace(/[^\d.]/g, "");
    },
    hospitalPhone: function(input) {
      //alert(input);
      input = PhoneFormatter(input);
      this.hospitalPhone = input;
      this.fnoldata.hospital.phone.work = input.replace(/[^\d.]/g, "");
    },
    "fnoldata.hospital.address.zip": function(input) {
      input = ZipFormatter(input);
      this.fnoldata.hospital.address.zip = input;
    },
    "fnoldata.physicianORClinic.address.zip": function(input) {
      input = ZipFormatter(input);
      this.fnoldata.physicianORClinic.address.zip = input;
    },
    "fnoldata.hospital.emergency": function(input){
      if(input == "No"){
        this.fnoldata.hospital.name = "";
        this.fnoldata.injury.hospitaliz = "No";
        this.fnoldata.hospital.phone.work = "";
        this.fnoldata.hospital.address.street="";
        this.fnoldata.hospital.address.city="";
        this.fnoldata.hospital.address.state="";
        this.fnoldata.hospital.address.zip="";
      }
    },
    "fnoldata.physicianORClinic.name": function(input){
      if(input == "No"){
        this.fnoldata.physicianORClinic.name = "";
        this.fnoldata.physicianORClinic.phone.work = "";
        this.fnoldata.physicianORClinic.address.street="";
        this.fnoldata.physicianORClinic.address.city="";
        this.fnoldata.physicianORClinic.address.state="";
        this.fnoldata.physicianORClinic.address.zip="";
      }
    }
  }
};
</script>

